/**
 * Inservice External Integrations
 * Inservice external integrations API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { CapacitorHttp } from '@capacitor/core';
import { HttpParameterCodec, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { CustomHttpParameterCodec } from '../encoder';
import Session from 'supertokens-web-js/recipe/session';
import { AuthStrategy } from '@generator-strategies/auth-strategy';
import { LanguageStrategy } from '@generator-strategies/language-strategy';
import { TenantStrategy } from '@generator-strategies/tenant-strategy';

// @ts-ignore
import { AppointmentResponseDto } from '../model/appointmentResponseDto';
// @ts-ignore
import { CheckAllSlotStatusUserReqDto } from '../model/checkAllSlotStatusUserReqDto';
// @ts-ignore
import { CheckSlotStatusReqDto } from '../model/checkSlotStatusReqDto';
// @ts-ignore
import { CheckedSlotResponseDto } from '../model/checkedSlotResponseDto';
// @ts-ignore
import { CheckinLinesReqDto } from '../model/checkinLinesReqDto';
// @ts-ignore
import { CheckinLinesResponseDto } from '../model/checkinLinesResponseDto';
// @ts-ignore
import { CreateAppointmentDto } from '../model/createAppointmentDto';
// @ts-ignore
import { CreateScheduleResponseDto } from '../model/createScheduleResponseDto';
// @ts-ignore
import { CreateScheduleUserReqDto } from '../model/createScheduleUserReqDto';
// @ts-ignore
import { DeleteSlotStatusReqDto } from '../model/deleteSlotStatusReqDto';
// @ts-ignore
import { DeleteSlotStatusResponseDto } from '../model/deleteSlotStatusResponseDto';
// @ts-ignore
import { GetAppointmentResponseDto } from '../model/getAppointmentResponseDto';
// @ts-ignore
import { GetCheckinLinesBulkReqDto } from '../model/getCheckinLinesBulkReqDto';
// @ts-ignore
import { GetCheckinLinesBulkResponseDto } from '../model/getCheckinLinesBulkResponseDto';
// @ts-ignore
import { GetDaySlotsReqDto } from '../model/getDaySlotsReqDto';
// @ts-ignore
import { GetDaySlotsResponseDto } from '../model/getDaySlotsResponseDto';
// @ts-ignore
import { GetSlotsBySchedulesReqDto } from '../model/getSlotsBySchedulesReqDto';
// @ts-ignore
import { GetSlotsBySchedulesResponseDto } from '../model/getSlotsBySchedulesResponseDto';
// @ts-ignore
import { IAppointment } from '../model/iAppointment';
// @ts-ignore
import { InsertSlotStatusResponseDto } from '../model/insertSlotStatusResponseDto';
// @ts-ignore
import { InsertSlotStatusUserReqDto } from '../model/insertSlotStatusUserReqDto';
// @ts-ignore
import { RevspringUserResponseDto } from '../model/revspringUserResponseDto';
// @ts-ignore
import { UpdateCheckinStatusUserReqDto } from '../model/updateCheckinStatusUserReqDto';
// @ts-ignore
import { UpdateRevspringUserUserReqDto } from '../model/updateRevspringUserUserReqDto';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';

@Injectable({
  providedIn: 'root'
})
export class NLSchedulingUserService {
  protected basePath = 'http://localhost';
  public defaultHeaders: any = {};
  public configuration = new Configuration();
  public encoder: HttpParameterCodec;

  constructor(
    @Optional()@Inject(BASE_PATH) basePath: string|string[],
    @Optional() configuration: Configuration,
    @Optional() private readonly authStrategy: AuthStrategy,
    @Optional() private readonly languageStrategy: LanguageStrategy,
    @Optional() private readonly tenantStrategy: TenantStrategy,
  ) {
    if (configuration) {
      this.configuration = configuration;
    }
    if (typeof this.configuration.basePath !== 'string') {
      if (Array.isArray(basePath) && basePath.length > 0) {
        basePath = basePath[0];
      }

      if (typeof basePath !== 'string') {
        basePath = this.basePath;
      }
      this.configuration.basePath = basePath;
    }
    this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
  }


  /**
   * @param xTENANTID
   * @param patientId Patient ID
   * @param createAppointmentDto
   */
  public async nlSchedulingUserControllerBookAppointment(xTENANTID: string, patientId: string, createAppointmentDto: CreateAppointmentDto, ): Promise<AppointmentResponseDto> {
    if (xTENANTID === null || xTENANTID === undefined) {
      throw new Error('Required parameter xTENANTID was null or undefined when calling nlSchedulingUserControllerBookAppointment.');
    }
    if (patientId === null || patientId === undefined) {
      throw new Error('Required parameter patientId was null or undefined when calling nlSchedulingUserControllerBookAppointment.');
    }
    if (createAppointmentDto === null || createAppointmentDto === undefined) {
      throw new Error('Required parameter createAppointmentDto was null or undefined when calling nlSchedulingUserControllerBookAppointment.');
    }

    const localVarHeaders = this.defaultHeaders;
    if (xTENANTID) {
      localVarHeaders['X-TENANT-ID'] = String(xTENANTID);
    }

    const accessToken = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${accessToken}`;
    localVarHeaders['Accept-Language'] = this.languageStrategy?.currentLanguage() ?? 'en';
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = localVarHeaders['X-TENANT-ID'] || this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/external-integrations/nl-scheduling/patients/${this.configuration.encodeParam({name: "patientId", value: patientId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/book-appointment`,
        data: createAppointmentDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * @param xTENANTID
   * @param patientId Patient ID
   * @param checkAllSlotStatusUserReqDto
   */
  public async nlSchedulingUserControllerCheckAllSlotStatus(xTENANTID: string, patientId: string, checkAllSlotStatusUserReqDto: CheckAllSlotStatusUserReqDto, ): Promise<Array<CheckedSlotResponseDto>> {
    if (xTENANTID === null || xTENANTID === undefined) {
      throw new Error('Required parameter xTENANTID was null or undefined when calling nlSchedulingUserControllerCheckAllSlotStatus.');
    }
    if (patientId === null || patientId === undefined) {
      throw new Error('Required parameter patientId was null or undefined when calling nlSchedulingUserControllerCheckAllSlotStatus.');
    }
    if (checkAllSlotStatusUserReqDto === null || checkAllSlotStatusUserReqDto === undefined) {
      throw new Error('Required parameter checkAllSlotStatusUserReqDto was null or undefined when calling nlSchedulingUserControllerCheckAllSlotStatus.');
    }

    const localVarHeaders = this.defaultHeaders;
    if (xTENANTID) {
      localVarHeaders['X-TENANT-ID'] = String(xTENANTID);
    }

    const accessToken = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${accessToken}`;
    localVarHeaders['Accept-Language'] = this.languageStrategy?.currentLanguage() ?? 'en';
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = localVarHeaders['X-TENANT-ID'] || this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/external-integrations/nl-scheduling/patients/${this.configuration.encodeParam({name: "patientId", value: patientId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/check-all-slot-status`,
        data: checkAllSlotStatusUserReqDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * @param xTENANTID
   * @param patientId Patient ID
   * @param checkSlotStatusReqDto
   */
  public async nlSchedulingUserControllerCheckSlotStatus(xTENANTID: string, patientId: string, checkSlotStatusReqDto: CheckSlotStatusReqDto, ): Promise<CheckedSlotResponseDto> {
    if (xTENANTID === null || xTENANTID === undefined) {
      throw new Error('Required parameter xTENANTID was null or undefined when calling nlSchedulingUserControllerCheckSlotStatus.');
    }
    if (patientId === null || patientId === undefined) {
      throw new Error('Required parameter patientId was null or undefined when calling nlSchedulingUserControllerCheckSlotStatus.');
    }
    if (checkSlotStatusReqDto === null || checkSlotStatusReqDto === undefined) {
      throw new Error('Required parameter checkSlotStatusReqDto was null or undefined when calling nlSchedulingUserControllerCheckSlotStatus.');
    }

    const localVarHeaders = this.defaultHeaders;
    if (xTENANTID) {
      localVarHeaders['X-TENANT-ID'] = String(xTENANTID);
    }

    const accessToken = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${accessToken}`;
    localVarHeaders['Accept-Language'] = this.languageStrategy?.currentLanguage() ?? 'en';
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = localVarHeaders['X-TENANT-ID'] || this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/external-integrations/nl-scheduling/patients/${this.configuration.encodeParam({name: "patientId", value: patientId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/check-slot-status`,
        data: checkSlotStatusReqDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * @param xTENANTID
   * @param patientId Patient ID
   * @param createScheduleUserReqDto
   */
  public async nlSchedulingUserControllerCreateSchedule(xTENANTID: string, patientId: string, createScheduleUserReqDto: CreateScheduleUserReqDto, ): Promise<CreateScheduleResponseDto> {
    if (xTENANTID === null || xTENANTID === undefined) {
      throw new Error('Required parameter xTENANTID was null or undefined when calling nlSchedulingUserControllerCreateSchedule.');
    }
    if (patientId === null || patientId === undefined) {
      throw new Error('Required parameter patientId was null or undefined when calling nlSchedulingUserControllerCreateSchedule.');
    }
    if (createScheduleUserReqDto === null || createScheduleUserReqDto === undefined) {
      throw new Error('Required parameter createScheduleUserReqDto was null or undefined when calling nlSchedulingUserControllerCreateSchedule.');
    }

    const localVarHeaders = this.defaultHeaders;
    if (xTENANTID) {
      localVarHeaders['X-TENANT-ID'] = String(xTENANTID);
    }

    const accessToken = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${accessToken}`;
    localVarHeaders['Accept-Language'] = this.languageStrategy?.currentLanguage() ?? 'en';
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = localVarHeaders['X-TENANT-ID'] || this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/external-integrations/nl-scheduling/patients/${this.configuration.encodeParam({name: "patientId", value: patientId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/create-schedule`,
        data: createScheduleUserReqDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * @param xTENANTID
   * @param patientId Patient ID
   * @param deleteSlotStatusReqDto
   */
  public async nlSchedulingUserControllerDeleteSlotStatus(xTENANTID: string, patientId: string, deleteSlotStatusReqDto: DeleteSlotStatusReqDto, ): Promise<DeleteSlotStatusResponseDto> {
    if (xTENANTID === null || xTENANTID === undefined) {
      throw new Error('Required parameter xTENANTID was null or undefined when calling nlSchedulingUserControllerDeleteSlotStatus.');
    }
    if (patientId === null || patientId === undefined) {
      throw new Error('Required parameter patientId was null or undefined when calling nlSchedulingUserControllerDeleteSlotStatus.');
    }
    if (deleteSlotStatusReqDto === null || deleteSlotStatusReqDto === undefined) {
      throw new Error('Required parameter deleteSlotStatusReqDto was null or undefined when calling nlSchedulingUserControllerDeleteSlotStatus.');
    }

    const localVarHeaders = this.defaultHeaders;
    if (xTENANTID) {
      localVarHeaders['X-TENANT-ID'] = String(xTENANTID);
    }

    const accessToken = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${accessToken}`;
    localVarHeaders['Accept-Language'] = this.languageStrategy?.currentLanguage() ?? 'en';
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = localVarHeaders['X-TENANT-ID'] || this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/external-integrations/nl-scheduling/patients/${this.configuration.encodeParam({name: "patientId", value: patientId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/delete-slot-status`,
        data: deleteSlotStatusReqDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * @param xTENANTID
   * @param patientId Patient ID
   */
  public async nlSchedulingUserControllerGetAllSchedules(xTENANTID: string, patientId: string, ): Promise<Array<IAppointment>> {
    if (xTENANTID === null || xTENANTID === undefined) {
      throw new Error('Required parameter xTENANTID was null or undefined when calling nlSchedulingUserControllerGetAllSchedules.');
    }
    if (patientId === null || patientId === undefined) {
      throw new Error('Required parameter patientId was null or undefined when calling nlSchedulingUserControllerGetAllSchedules.');
    }

    const localVarHeaders = this.defaultHeaders;
    if (xTENANTID) {
      localVarHeaders['X-TENANT-ID'] = String(xTENANTID);
    }

    const accessToken = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${accessToken}`;
    localVarHeaders['Accept-Language'] = this.languageStrategy?.currentLanguage() ?? 'en';
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = localVarHeaders['X-TENANT-ID'] || this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.get({
      url: `${this.configuration.basePath}/api/external-integrations/nl-scheduling/patients/${this.configuration.encodeParam({name: "patientId", value: patientId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/get-all-schedules`,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * @param xTENANTID
   * @param patientId Patient ID
   * @param prodOrgID
   * @param testOrgID
   * @param scheduleDay
   */
  public async nlSchedulingUserControllerGetAppointments(xTENANTID: string, patientId: string, prodOrgID: string, testOrgID: string, scheduleDay: string, ): Promise<GetAppointmentResponseDto> {
    if (xTENANTID === null || xTENANTID === undefined) {
      throw new Error('Required parameter xTENANTID was null or undefined when calling nlSchedulingUserControllerGetAppointments.');
    }
    if (patientId === null || patientId === undefined) {
      throw new Error('Required parameter patientId was null or undefined when calling nlSchedulingUserControllerGetAppointments.');
    }
    if (prodOrgID === null || prodOrgID === undefined) {
      throw new Error('Required parameter prodOrgID was null or undefined when calling nlSchedulingUserControllerGetAppointments.');
    }
    if (testOrgID === null || testOrgID === undefined) {
      throw new Error('Required parameter testOrgID was null or undefined when calling nlSchedulingUserControllerGetAppointments.');
    }
    if (scheduleDay === null || scheduleDay === undefined) {
      throw new Error('Required parameter scheduleDay was null or undefined when calling nlSchedulingUserControllerGetAppointments.');
    }

    const localVarQueryParameters = new URLSearchParams();
    if (prodOrgID !== undefined && prodOrgID !== null) {
      localVarQueryParameters.append('prodOrgID', String(prodOrgID));
    }
    if (testOrgID !== undefined && testOrgID !== null) {
      localVarQueryParameters.append('testOrgID', String(testOrgID));
    }
    if (scheduleDay !== undefined && scheduleDay !== null) {
      localVarQueryParameters.append('scheduleDay', String(scheduleDay));
    }

    const localVarHeaders = this.defaultHeaders;
    if (xTENANTID) {
      localVarHeaders['X-TENANT-ID'] = String(xTENANTID);
    }

    const accessToken = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${accessToken}`;
    localVarHeaders['Accept-Language'] = this.languageStrategy?.currentLanguage() ?? 'en';
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = localVarHeaders['X-TENANT-ID'] || this.tenantStrategy?.organizationId();
    const queryString = localVarQueryParameters.toString();
    const urlWithParams = queryString ? `${this.configuration.basePath}/api/external-integrations/nl-scheduling/patients/${this.configuration.encodeParam({name: "patientId", value: patientId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/get-appointments?${queryString}` : `${this.configuration.basePath}/api/external-integrations/nl-scheduling/patients/${this.configuration.encodeParam({name: "patientId", value: patientId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/get-appointments`;
    const response = await CapacitorHttp.get({
      url: urlWithParams,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * @param xTENANTID
   * @param patientId Patient ID
   * @param checkinLinesReqDto
   */
  public async nlSchedulingUserControllerGetCheckinLines(xTENANTID: string, patientId: string, checkinLinesReqDto: CheckinLinesReqDto, ): Promise<CheckinLinesResponseDto> {
    if (xTENANTID === null || xTENANTID === undefined) {
      throw new Error('Required parameter xTENANTID was null or undefined when calling nlSchedulingUserControllerGetCheckinLines.');
    }
    if (patientId === null || patientId === undefined) {
      throw new Error('Required parameter patientId was null or undefined when calling nlSchedulingUserControllerGetCheckinLines.');
    }
    if (checkinLinesReqDto === null || checkinLinesReqDto === undefined) {
      throw new Error('Required parameter checkinLinesReqDto was null or undefined when calling nlSchedulingUserControllerGetCheckinLines.');
    }

    const localVarHeaders = this.defaultHeaders;
    if (xTENANTID) {
      localVarHeaders['X-TENANT-ID'] = String(xTENANTID);
    }

    const accessToken = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${accessToken}`;
    localVarHeaders['Accept-Language'] = this.languageStrategy?.currentLanguage() ?? 'en';
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = localVarHeaders['X-TENANT-ID'] || this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/external-integrations/nl-scheduling/patients/${this.configuration.encodeParam({name: "patientId", value: patientId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/get-checkin-lines`,
        data: checkinLinesReqDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * @param xTENANTID
   * @param patientId Patient ID
   * @param getCheckinLinesBulkReqDto
   */
  public async nlSchedulingUserControllerGetCheckinLinesBulk(xTENANTID: string, patientId: string, getCheckinLinesBulkReqDto: GetCheckinLinesBulkReqDto, ): Promise<GetCheckinLinesBulkResponseDto> {
    if (xTENANTID === null || xTENANTID === undefined) {
      throw new Error('Required parameter xTENANTID was null or undefined when calling nlSchedulingUserControllerGetCheckinLinesBulk.');
    }
    if (patientId === null || patientId === undefined) {
      throw new Error('Required parameter patientId was null or undefined when calling nlSchedulingUserControllerGetCheckinLinesBulk.');
    }
    if (getCheckinLinesBulkReqDto === null || getCheckinLinesBulkReqDto === undefined) {
      throw new Error('Required parameter getCheckinLinesBulkReqDto was null or undefined when calling nlSchedulingUserControllerGetCheckinLinesBulk.');
    }

    const localVarHeaders = this.defaultHeaders;
    if (xTENANTID) {
      localVarHeaders['X-TENANT-ID'] = String(xTENANTID);
    }

    const accessToken = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${accessToken}`;
    localVarHeaders['Accept-Language'] = this.languageStrategy?.currentLanguage() ?? 'en';
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = localVarHeaders['X-TENANT-ID'] || this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/external-integrations/nl-scheduling/patients/${this.configuration.encodeParam({name: "patientId", value: patientId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/get-checkin-lines-bulk`,
        data: getCheckinLinesBulkReqDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * @param xTENANTID
   * @param patientId Patient ID
   * @param getDaySlotsReqDto
   */
  public async nlSchedulingUserControllerGetDaySlots(xTENANTID: string, patientId: string, getDaySlotsReqDto: GetDaySlotsReqDto, ): Promise<GetDaySlotsResponseDto> {
    if (xTENANTID === null || xTENANTID === undefined) {
      throw new Error('Required parameter xTENANTID was null or undefined when calling nlSchedulingUserControllerGetDaySlots.');
    }
    if (patientId === null || patientId === undefined) {
      throw new Error('Required parameter patientId was null or undefined when calling nlSchedulingUserControllerGetDaySlots.');
    }
    if (getDaySlotsReqDto === null || getDaySlotsReqDto === undefined) {
      throw new Error('Required parameter getDaySlotsReqDto was null or undefined when calling nlSchedulingUserControllerGetDaySlots.');
    }

    const localVarHeaders = this.defaultHeaders;
    if (xTENANTID) {
      localVarHeaders['X-TENANT-ID'] = String(xTENANTID);
    }

    const accessToken = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${accessToken}`;
    localVarHeaders['Accept-Language'] = this.languageStrategy?.currentLanguage() ?? 'en';
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = localVarHeaders['X-TENANT-ID'] || this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/external-integrations/nl-scheduling/patients/${this.configuration.encodeParam({name: "patientId", value: patientId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/get-day-slots`,
        data: getDaySlotsReqDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * @param xTENANTID
   * @param patientId Patient ID
   */
  public async nlSchedulingUserControllerGetHealthCoachAppointments(xTENANTID: string, patientId: string, ): Promise<Array<IAppointment>> {
    if (xTENANTID === null || xTENANTID === undefined) {
      throw new Error('Required parameter xTENANTID was null or undefined when calling nlSchedulingUserControllerGetHealthCoachAppointments.');
    }
    if (patientId === null || patientId === undefined) {
      throw new Error('Required parameter patientId was null or undefined when calling nlSchedulingUserControllerGetHealthCoachAppointments.');
    }

    const localVarHeaders = this.defaultHeaders;
    if (xTENANTID) {
      localVarHeaders['X-TENANT-ID'] = String(xTENANTID);
    }

    const accessToken = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${accessToken}`;
    localVarHeaders['Accept-Language'] = this.languageStrategy?.currentLanguage() ?? 'en';
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = localVarHeaders['X-TENANT-ID'] || this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.get({
      url: `${this.configuration.basePath}/api/external-integrations/nl-scheduling/patients/${this.configuration.encodeParam({name: "patientId", value: patientId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/get-health-coach-appointments`,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * @param xTENANTID
   * @param patientId Patient ID
   */
  public async nlSchedulingUserControllerGetOrCreateUser(xTENANTID: string, patientId: string, ): Promise<RevspringUserResponseDto> {
    if (xTENANTID === null || xTENANTID === undefined) {
      throw new Error('Required parameter xTENANTID was null or undefined when calling nlSchedulingUserControllerGetOrCreateUser.');
    }
    if (patientId === null || patientId === undefined) {
      throw new Error('Required parameter patientId was null or undefined when calling nlSchedulingUserControllerGetOrCreateUser.');
    }

    const localVarHeaders = this.defaultHeaders;
    if (xTENANTID) {
      localVarHeaders['X-TENANT-ID'] = String(xTENANTID);
    }

    const accessToken = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${accessToken}`;
    localVarHeaders['Accept-Language'] = this.languageStrategy?.currentLanguage() ?? 'en';
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = localVarHeaders['X-TENANT-ID'] || this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/external-integrations/nl-scheduling/patients/${this.configuration.encodeParam({name: "patientId", value: patientId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/current-user`,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * @param xTENANTID
   * @param patientId Patient ID
   * @param getSlotsBySchedulesReqDto
   */
  public async nlSchedulingUserControllerGetSlotsBySchedules(xTENANTID: string, patientId: string, getSlotsBySchedulesReqDto: GetSlotsBySchedulesReqDto, ): Promise<GetSlotsBySchedulesResponseDto> {
    if (xTENANTID === null || xTENANTID === undefined) {
      throw new Error('Required parameter xTENANTID was null or undefined when calling nlSchedulingUserControllerGetSlotsBySchedules.');
    }
    if (patientId === null || patientId === undefined) {
      throw new Error('Required parameter patientId was null or undefined when calling nlSchedulingUserControllerGetSlotsBySchedules.');
    }
    if (getSlotsBySchedulesReqDto === null || getSlotsBySchedulesReqDto === undefined) {
      throw new Error('Required parameter getSlotsBySchedulesReqDto was null or undefined when calling nlSchedulingUserControllerGetSlotsBySchedules.');
    }

    const localVarHeaders = this.defaultHeaders;
    if (xTENANTID) {
      localVarHeaders['X-TENANT-ID'] = String(xTENANTID);
    }

    const accessToken = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${accessToken}`;
    localVarHeaders['Accept-Language'] = this.languageStrategy?.currentLanguage() ?? 'en';
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = localVarHeaders['X-TENANT-ID'] || this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/external-integrations/nl-scheduling/patients/${this.configuration.encodeParam({name: "patientId", value: patientId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/get-slots-by-schedules`,
        data: getSlotsBySchedulesReqDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * @param xTENANTID
   * @param patientId Patient ID
   */
  public async nlSchedulingUserControllerGetVirtualAppointments(xTENANTID: string, patientId: string, ): Promise<Array<IAppointment>> {
    if (xTENANTID === null || xTENANTID === undefined) {
      throw new Error('Required parameter xTENANTID was null or undefined when calling nlSchedulingUserControllerGetVirtualAppointments.');
    }
    if (patientId === null || patientId === undefined) {
      throw new Error('Required parameter patientId was null or undefined when calling nlSchedulingUserControllerGetVirtualAppointments.');
    }

    const localVarHeaders = this.defaultHeaders;
    if (xTENANTID) {
      localVarHeaders['X-TENANT-ID'] = String(xTENANTID);
    }

    const accessToken = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${accessToken}`;
    localVarHeaders['Accept-Language'] = this.languageStrategy?.currentLanguage() ?? 'en';
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = localVarHeaders['X-TENANT-ID'] || this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.get({
      url: `${this.configuration.basePath}/api/external-integrations/nl-scheduling/patients/${this.configuration.encodeParam({name: "patientId", value: patientId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/get-virtual-appointments`,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * @param xTENANTID
   * @param patientId Patient ID
   * @param insertSlotStatusUserReqDto
   */
  public async nlSchedulingUserControllerInsertSlotStatus(xTENANTID: string, patientId: string, insertSlotStatusUserReqDto: InsertSlotStatusUserReqDto, ): Promise<InsertSlotStatusResponseDto> {
    if (xTENANTID === null || xTENANTID === undefined) {
      throw new Error('Required parameter xTENANTID was null or undefined when calling nlSchedulingUserControllerInsertSlotStatus.');
    }
    if (patientId === null || patientId === undefined) {
      throw new Error('Required parameter patientId was null or undefined when calling nlSchedulingUserControllerInsertSlotStatus.');
    }
    if (insertSlotStatusUserReqDto === null || insertSlotStatusUserReqDto === undefined) {
      throw new Error('Required parameter insertSlotStatusUserReqDto was null or undefined when calling nlSchedulingUserControllerInsertSlotStatus.');
    }

    const localVarHeaders = this.defaultHeaders;
    if (xTENANTID) {
      localVarHeaders['X-TENANT-ID'] = String(xTENANTID);
    }

    const accessToken = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${accessToken}`;
    localVarHeaders['Accept-Language'] = this.languageStrategy?.currentLanguage() ?? 'en';
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = localVarHeaders['X-TENANT-ID'] || this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/external-integrations/nl-scheduling/patients/${this.configuration.encodeParam({name: "patientId", value: patientId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/insert-slot-status`,
        data: insertSlotStatusUserReqDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * @param xTENANTID
   * @param patientId Patient ID
   * @param updateCheckinStatusUserReqDto
   */
  public async nlSchedulingUserControllerUpdateCheckinStatus(xTENANTID: string, patientId: string, updateCheckinStatusUserReqDto: UpdateCheckinStatusUserReqDto, ): Promise<any> {
    if (xTENANTID === null || xTENANTID === undefined) {
      throw new Error('Required parameter xTENANTID was null or undefined when calling nlSchedulingUserControllerUpdateCheckinStatus.');
    }
    if (patientId === null || patientId === undefined) {
      throw new Error('Required parameter patientId was null or undefined when calling nlSchedulingUserControllerUpdateCheckinStatus.');
    }
    if (updateCheckinStatusUserReqDto === null || updateCheckinStatusUserReqDto === undefined) {
      throw new Error('Required parameter updateCheckinStatusUserReqDto was null or undefined when calling nlSchedulingUserControllerUpdateCheckinStatus.');
    }

    const localVarHeaders = this.defaultHeaders;
    if (xTENANTID) {
      localVarHeaders['X-TENANT-ID'] = String(xTENANTID);
    }

    const accessToken = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${accessToken}`;
    localVarHeaders['Accept-Language'] = this.languageStrategy?.currentLanguage() ?? 'en';
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = localVarHeaders['X-TENANT-ID'] || this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/external-integrations/nl-scheduling/patients/${this.configuration.encodeParam({name: "patientId", value: patientId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/update-checkin-status`,
        data: updateCheckinStatusUserReqDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * @param xTENANTID
   * @param patientId Patient ID
   * @param updateRevspringUserUserReqDto
   */
  public async nlSchedulingUserControllerUpdateUser(xTENANTID: string, patientId: string, updateRevspringUserUserReqDto: UpdateRevspringUserUserReqDto, ): Promise<RevspringUserResponseDto> {
    if (xTENANTID === null || xTENANTID === undefined) {
      throw new Error('Required parameter xTENANTID was null or undefined when calling nlSchedulingUserControllerUpdateUser.');
    }
    if (patientId === null || patientId === undefined) {
      throw new Error('Required parameter patientId was null or undefined when calling nlSchedulingUserControllerUpdateUser.');
    }
    if (updateRevspringUserUserReqDto === null || updateRevspringUserUserReqDto === undefined) {
      throw new Error('Required parameter updateRevspringUserUserReqDto was null or undefined when calling nlSchedulingUserControllerUpdateUser.');
    }

    const localVarHeaders = this.defaultHeaders;
    if (xTENANTID) {
      localVarHeaders['X-TENANT-ID'] = String(xTENANTID);
    }

    const accessToken = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${accessToken}`;
    localVarHeaders['Accept-Language'] = this.languageStrategy?.currentLanguage() ?? 'en';
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = localVarHeaders['X-TENANT-ID'] || this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/external-integrations/nl-scheduling/patients/${this.configuration.encodeParam({name: "patientId", value: patientId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/update-user`,
        data: updateRevspringUserUserReqDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
}
